// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InternalNetworkExecutionTierSchema = z.enum(['VALIDATION_ONLY','CONTROLLED_AD','FULL_LATERAL_MOVEMENT'] as const);

export type InternalNetworkExecutionTierType = `${z.infer<typeof InternalNetworkExecutionTierSchema>}`

export default InternalNetworkExecutionTierSchema;
